<template>
	<div class="c-block-view-assets">
		<div class="c-block-view-assets__item" v-for="(asset, i) in assets" :key="i">
			<Header :title="getHeaderTitle(i)" :asset="asset"></Header>
			<div class="c-block-view-assets__renderer" :style="computedViewerStyle">
				<video v-if="asset.type === 'video'" :key="asset.assetPath" :poster="setCover(asset)" controls>
					<source :src="`${assetUrl}/${asset.assetPath}`" type="video/mp4" />
				</video>
				<lite-youtube v-if="asset.type === 'youtube'" :videoid="asset.id"></lite-youtube>
				<img v-if="asset.type !== 'video' && asset.type !== 'youtube'" :src="`${assetUrl}/${asset.assetPath}`" />
			</div>
			<article v-if="asset.title || asset.body">
				<section title="Ad title">
					<Copy :text="asset.title"></Copy>
					<strong>
						{{ asset.title }}
					</strong>
				</section>
				<section title="Ad Copy" v-if="asset.body">
					<Copy :text="asset.body"></Copy>
					<p>{{ asset.body }}</p>
				</section>
				<a :href="getAssetLinkUrl(asset)" target="_blank" v-if="getAssetLinkUrl(asset) && getAssetCtaText(asset)" type="button" class="btn btn-box">
					{{ getAssetCtaText(asset) }}
				</a>
				<button v-if="!getAssetLinkUrl(asset) && getAssetCtaText(asset)" type="button" class="btn btn-box">
					{{ getAssetCtaText(asset) }}
				</button>
				<section v-if="asset.link_description" title="Ad link description">
					<Copy :text="asset.link_description"></Copy>
					<small>{{ asset.link_description }}</small>
				</section>
			</article>
		</div>
		<div v-if="screenshot && !showLandingPageScreenshots" class="c-block-view-assets__item">
			<button type="button" @click="onLandingPageView" class="btn">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M3 5C3 3.89543 3.89543 3 5 3H8C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H5V8C5 8.55228 4.55228 9 4 9C3.44772 9 3 8.55228 3 8V5ZM15 4C15 3.44772 15.4477 3 16 3H19C20.1046 3 21 3.89543 21 5V8C21 8.55228 20.5523 9 20 9C19.4477 9 19 8.55228 19 8V5H16C15.4477 5 15 4.55228 15 4ZM4 15C4.55228 15 5 15.4477 5 16V19H8C8.55228 19 9 19.4477 9 20C9 20.5523 8.55228 21 8 21H5C3.89543 21 3 20.1046 3 19V16C3 15.4477 3.44772 15 4 15ZM20 15C20.5523 15 21 15.4477 21 16V19C21 20.1046 20.1046 21 19 21H16C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19H19V16C19 15.4477 19.4477 15 20 15Z"
						fill="currentColor"
					/>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M10 7.58579C10.3751 7.21071 10.8838 7 11.4142 7H12.5858C13.1162 7 13.6249 7.21071 14 7.58579L14.4142 8H15C16.1046 8 17 8.89543 17 10V14C17 15.1046 16.1046 16 15 16H9C7.89543 16 7 15.1046 7 14V10C7 8.89543 7.89543 8 9 8H9.58579L10 7.58579ZM10.5 11.85C10.5 11.0216 11.1716 10.35 12 10.35C12.8284 10.35 13.5 11.0216 13.5 11.85C13.5 12.6784 12.8284 13.35 12 13.35C11.1716 13.35 10.5 12.6784 10.5 11.85Z"
						fill="currentColor"
					/>
				</svg>

				<span> View Landing page screenshots </span>
			</button>
		</div>
		<template v-if="showLandingPageScreenshots">
			<div class="c-block-view-assets__item" v-if="screenshot && screenshot.assets[0]">
				<Header title="Landing page screenshot(desktop)" :asset="screenshot.assets[0]"></Header>
				<div class="c-block-view-assets__renderer">
					<img :src="`${assetUrl}/${screenshot.assets[0].assetPath}`" />
				</div>
			</div>
			<div class="c-block-view-assets__item" v-if="screenshot && screenshot.assets[1]">
				<Header title="Landing page screenshot(mobile)" :asset="screenshot.assets[1]"></Header>
				<div class="c-block-view-assets__renderer">
					<img :src="`${assetUrl}/${screenshot.assets[1].assetPath}`" />
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import Header from './asset-header';
import Copy from './copy';

import api from '@swipekit/lib/api.js';

export default {
	components: {
		Header,
		Copy,
	},

	data: function () {
		return {
			showLandingPageScreenshots: false,
		};
	},

	props: {
		block: {},
	},

	computed: {
		screenshot: function () {
			return this.block.screenshot || this.block.screenshotBlock;
		},
		computedViewerStyle: function () {
			return {};
			let assetRatio = 1;
			if (this.block && this.block.assetRatio) {
				assetRatio = this.block.assetRatio;
			}

			let padding = assetRatio * 100;
			let str = `padding-bottom:${padding}%;`;

			return str;
		},
		baseUrl: function () {
			return this.$store.getters['config/baseUrl'];
		},
		assetUrl: function () {
			return this.$store.getters['config/assetUrl'];
		},
		assets: function () {
			let assets = this.block.assets;

			return assets;
		},
	},

	methods: {
		onLandingPageView: function () {
			this.showLandingPageScreenshots = true;

			let payload = {
				name: `landing_page_screenshots_viewed`,
				blockId: this.block.id,
			};

			api.api.track(payload);
		},
		getAssetCtaText: function (asset) {
			if (asset.cta_text) {
				return asset.cta_text || '';
			}
			return null;
		},
		getAssetLinkUrl: function (asset) {
			if (asset.link_url) {
				return asset.link_url || '';
			}
			return null;
		},
		setCover: function (asset) {
			if (!asset.cover) {
				return;
			}

			let assetUrl = this.assetUrl;

			let url = `${assetUrl}/${asset.cover.assetPath}`;

			return url;
		},
		getHeaderTitle: function (i) {
			if (this.block && this.block.meta && this.block.meta.dco) {
				let index = i + 1;
				let str = this.getVariation(index, 'DCO', 'asset');

				return str;
			} else if (this.block && this.block.meta && this.block.meta.dpa) {
				let index = i + 1;
				let str = this.getVariation(index, 'DPA', 'asset');

				return str;
			} else if (this.block.assetType === 'carousel') {
				let index = i + 1;
				let str = this.getVariation(index, 'Carousel', 'slide');

				return str;
			} else {
				return 'Primary Asset';
			}
		},
		getVariation: function (i, pre = 'DCO', post = 'slide') {
			if (i === 1) {
				return `${pre} – 1st ${post}`;
			}
			if (i === 2) {
				return `${pre} – 2nd ${post}`;
			}
			if (i === 3) {
				return `${pre} – 3rd ${post}`;
			}

			return `${pre} – ${i}th ${post}`;
		},
	},
};
</script>

<style lang="scss">
.c-block-view-assets {
	width: 100%;
	padding: var(--margin-lg);

	&__item {
		max-width: 600px;
		margin: 0 auto;
		position: relative;
		padding-top: var(--spacer-sm);
		padding-bottom: var(--spacer-sm);

		> .btn {
			margin: 0 auto;
			display: flex;
			align-items: center;
			font-weight: 500;
			line-height: 1;

			svg {
				margin-right: var(--margin);
			}
		}

		label {
			font-size: var(--font-size);
			font-weight: 500;
		}

		// video,
		// img {
		//   position: absolute;
		//   top: 0;
		//   left: 0;
		//   width: 100%;
		//   //height: calc(80px - (var(--margin) * 2));
		//   height: auto;
		//   object-fit: cover;
		//   border-radius: var(--border-radius);
		// }

		video,
		img {
			width: 100%;
			height: auto;
			border-radius: var(--border-radius);
			box-shadow: 0 0 0 1px rgba(17, 24, 28, 0.08), 0 1px 2px -1px rgba(17, 24, 28, 0.08), 0 2px 4px rgba(17, 24, 28, 0.04);
		}

		article {
			padding: var(--margin-lg);
			white-space: break-spaces;

			> section {
				display: grid;
				grid-template-columns: 24px 1fr;
			}

			> a,
			> button {
				margin-bottom: var(--margin-lg);
			}

			strong {
				display: block;
				font-weight: 500;
				margin-bottom: var(--margin-lg);
				opacity: 0.85;
			}

			p {
				opacity: 0.8;
			}
		}

		&:after {
			content: '';
			position: absolute;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 2px;
			background-color: var(--color-bg-5);
		}

		&:first-child {
			padding-top: 0;
		}

		&:last-child {
			&:after {
				display: none;
			}
		}
	}

	&__renderer {
		width: 100%;
		position: relative;
	}

	@media screen and (max-width: 1799px) {
		.c-block-view-assets__item {
			max-width: 100%;
			padding-left: var(--spacer-lg);
			padding-right: var(--spacer-lg);
		}
	}

	@media screen and (max-width: 1400px) {
		.c-block-view-assets__item {
			padding-left: var(--spacer-sm);
			padding-right: var(--spacer-sm);
		}
	}

	@media screen and (max-width: 960px) {
		.c-block-view-assets__item {
			padding-left: var(--margin-lg);
			padding-right: var(--margin-lg);
		}
	}

	@media screen and (min-width: 1800px) {
		.c-block-view-assets__item {
			max-width: 600px;
		}
	}
}
</style>
